import React from 'react';
import { CustomForm } from '@urbantxt/form';

import { ParagraphText } from '@urbantxt/paragraph-text';
import useChangePassword from '../../hooks/useChangePassword';
import styles from './ChangePasswordForm.module.scss';

/**
 * Change password form component
 * Used when user must change password on first login
 */
function ChangePasswordForm() {
  const { fields, formValue, isLoading, model, onChange, onSubmit } =
    useChangePassword();

  return (
    <div className={styles.container}>
      <div className={styles.headerContainer}>
        <ParagraphText>
          <strong>Password Change Required</strong>
        </ParagraphText>
        <ParagraphText marginTop={10}>
          Please set a new password to continue.
        </ParagraphText>
      </div>

      <CustomForm
        onChange={onChange}
        onSubmit={onSubmit}
        model={model}
        formValue={formValue}
        isLoading={isLoading}
        fields={fields}
        isDisabled={false}
        submitLabel="Change Password"
        hasChanges
        submitBtnSize="full"
      />
    </div>
  );
}

export default ChangePasswordForm;
